const PATCH_NOTES = [
  {
    title: `Versió ${process.env.VUE_APP_VERSION}`,
    date: '2025-05-09', // '09 de Mayo de 2025',
    changes: [
      {
        title: 'Nova funcionalitat multilingüe',
        description: [
          'S\'hi afegeixen idiomes \'Anglès\', \'Francès\', \'Alemany\', \'Català\', \'Gallego\' i \'Euskera\'.',
        ]
      },
      {
        title: 'Canvi a Agenda',
        description: [
          'Agenda canvia de nom a \'Sociedades\'.',
          'S\'afegeix a societats els apartats \'Empreses vinculades\' i \'istòric\'.',
          'S\'afegeix a Seus els apartats \'Email de contacte\' i \'Comptes bancaris\'.',
        ]
      },
      {
        title: 'Nou mòdul d\'Interfície d\'emissió de factures',
        description: [
          'Cal tenir activat el mòdul \'Emissió de factures\' per a un funcionament correcte.',
          'S\'hi afegeix nova funcionalitat per emetre factures per passos.',
          'S\'hi afegeixen els passos d\'emissió de factures \'Intervinientes\', \'Detalle\', \'Líneas\', \'Pago\' i \'Adjuntos\'.',
          'S\'hi afegeix resum de la factura.',
        ]
      },
      {
        title: 'Nou mòdul de Veri*Factu',
        description: [
          'S\'hi afegeixen registres de Veri*Factu.',
          'S\'hi afegeixen els estats \'Correcte\', \'Acceptat amb errors\', \'Incorrecte\' i \'Pendent de notificar\'.',
          'S\'hi afegeix detall de registres.',
        ]
      },
      {
        title: 'Correcció d\'errades',
        description: [
          'Correcció derrors menors.'
        ]
      },
    ]
  },
  {
    title: 'Versió 6.1.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Configuració Autenticació AAD/SAML2',
        description: [
          'Mòdul d\'autenticació amb integració mitjançant Azure Active Directory',
          'Mòdul d\'autenticació amb integració a través de l\'estàndard SAML2',
          'Inici de sessió dinàmica en funció del tipus d\'autenticació de l\'usuari'
        ]
      },
      {
        title: 'Nous mòduls de Webhooks',
        description: [
          'S\'hi afegeixen dos nous mòduls per als esdeveniments de les Factures Emeses i Rebudes',
          'S\'hi afegeix nova vista de configuració dels Webhooks. Integracio amb Microsoft Teams o Integracio personalitzada (Zerocoma)'
        ]
      },
      {
        title: 'Nou mòdul de TicketBAI-Batuz',
        description: [
          'S\'hi afegeix un apartat de configuració per a la integració a TicketBAI-Batuz.'
        ]
      },
      {
        title: 'Canvi al flux de \'Enviament Extern\'',
        description: [
          'S\'elimina l\'estat \'Enviament Extern\'.',
          'Les factures que es trobin en aquest estat passaran a l\'estat \'Enviada\'.',
          'Les factures amb pge \'Enviament Extern\' ara passen pel flux normal de factures.'
        ]
      },
      {
        title: 'Eliminació d\'accions a les factures emeses',
        description: [
          'S\'eliminen totes les accions \'Passar a\' de les factures en estat \'Sense Enviar\'.'
        ]
      },
      {
        title: 'Correcció d\'errades',
        description: [
          'Correcció derrors menors.'
        ]
      },
    ]
  },
  {
    title: 'Versió 6.0.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Nova funcionalitat d\'Agenda',
        description: [
          'S\'afegeix un apartat on es poden afegir diferents tipus de contactes.'
        ]
      },
      {
        title: 'Nova funcionalitat de Validació',
        description: [
          'Es creuen els fitxers de la factura amb els seus esquemes i es comproven els adjunts de forma prèvia a la pujada de la factura.'
        ]
      },
      {
        title: 'Nova funcionalitat de Plantilles',
        description: [
          'S\'hi afegeix una nova configuració amb valors per defecte per a la creació de noves empreses i nous grups.'
        ]
      },
      {
        title: 'Nou mòdul d\'autofactura',
        description: [
          'S\'hi afegeix l\'opció de pujar i emetre autofactures des de la plataforma.'
        ]
      },
      {
        title: 'Nou mòdul d\'Agrupacions',
        description: [
          'S\'hi afegeix una secció per crear conjunts d\'entitats (Empreses, Proveïdors o Clients) i utilitzar-los posteriorment en filtres i altres parts de l\'aplicatiu.'
        ]
      },
      {
        title: 'Nou mòdul de Personalització',
        description: [
          'S\'afegeixen diferents opcions de personalització com ara: Logos, colors, compte SMTP i emails personalitzats.'
        ]
      },
      {
        title: 'Nou mòdul de Plantilla PDF',
        description: [
          'S\'afegeix l\'opció de generar una factura pdf a partir del facturae segons una plantilla i configuració establerta.'
        ]
      },
      {
        title: 'Nou producte d\'EdasInvoiZEFiles',
        description: [
          'S\'afegeix l\'opció de pujar factures amb els vostres adjunts des del servei EdasInvoiZEFiles.'
        ]
      },
      {
        title: 'Possibilitat de pujar factures rebudes',
        description: [
          'S\'hi afegeix l\'opció de pujar factures rebudes manualment des del menú de "Pujar factures".'
        ]
      },
      {
        title: 'Reorganització de filtres',
        description: [
          'Es reorganitzen els filtres de les seccions relatives a les factures.'
        ]
      },
      {
        title: 'Correcció d\'errades',
        description: [
          'Correcció derrors menors.'
        ]
      },
    ]
  },
  {
    title: 'Versió 5.2.2',
    date: '2024-03-20', // '20 de Marzo de 2024',
    changes: [
      {
        title: 'Correcció de textos',
        description: [
          'Es corregeixen alguns textos a la validació del llicenciament.'
        ]
      },
      {
        title: 'Correcció d\'errades',
        description: [
          'Es corregeix la desaparició de la columna "Detall" de les taules relacionades amb les factures.'
        ]
      },
    ]
  },
  {
    title: 'Versió 5.2.1',
    date: '2024-03-18', // '18 de Marzo de 2024',
    changes: [
      {
        title: 'Actualització de textos',
        description: [
          'S\'actualitzen alguns textos dins de l\'aplicació per a més descriptivitat.'
        ]
      },
      {
        title: 'Millores d\'eficiència',
        description: [
          'S\'apliquen millores a l\'eficiència dels selectors dins de l\'aplicació.'
        ]
      },
      {
        title: 'Correcció d\'errades',
        description: [
          'Correcció derrors menors.'
        ]
      },
    ]
  },
  {
    title: 'Versió 5.2.0',
    date: '2024-02-27', // '27 de Febrero de 2024',
    changes: [
      {
        title: 'Ampliat els esquemes admesos per emissió',
        description: [
          'S\'hi afegeix compatibilitat i validació d\'altres esquemes a part del Facturae.'
        ]
      },
      {
        title: 'Signat i recuperació de factures per a enviament extern',
        description: [
          'S\'afegeix el Punt General de Lliurament Enviament extern, útil per fer únicament el signat de les factures per enviar de forma externa.'
        ]
      },
      {
        title: 'Nou Punt General de Lliurament Catalunya (e-Fact)',
        description: [
          'S\'hi afegeix el Punt General de Lliurament e-Fact per a l\'enviament de factures a les administracions de catalunya no adherides a FACe.',
          'Consulteu les administracions adherides a #link:eFact#.'
        ],
        links: [
          {
            tag: 'eFact',
            linkName: 'e-Fact',
            url: 'https://efact.aoc.cat/bustia/receiver/list.htm'
          }
        ]
      },
      {
        title: 'Recuperació de fitxers enviats',
        description: [
          'Si la factura a enviar ha patit alguna alteració per enviar al Punt General de Lliurament, s\'emmagatzemarà com a document relacionat de la factura.'
        ]
      },
      {
        title: 'Signatura de tercers',
        description: [
          'Tots aquells Facturas que se signin a través del certificat de Col·laborador Social, se\'ls inclourà les nostres dades com a tercers al node ThirdParty del Facturae.'
        ]
      },
      {
        title: 'Correcció d\'errades',
        description: [
          'Errors relacionats amb els transformadors ja existents.',
          'Correcció derrors menors.'
        ]
      },
    ]
  },
  {
    title: 'Versió 5.1.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Noves característiques',
        description: [
          'Nova funcionalitat de Dashboard: Nova vista amb informació útil sobre les factures i el llicenciament.'
        ]
      },
      {
        title: 'Altres canvis',
        description: [
          'Correccions menors.',
        ]
      },
    ]
  },
  {
    title: 'Versió 5.0.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Noves característiques',
        description: [
          'Nova funcionalitat de Distribuïdor: Gestiona múltiples clients com a distribuïdor amb proveïment amb borsa de llicenciament o de forma lliure.',
        ]
      },
    ]
  }, 
  {
    title: 'Versió 4.2.0',
    date: '2023-10-30', // '30 de Octubre de 2023',
    changes: [
      {
        title: 'Noves característiques',
        description: [
          'Nova funcionalitat de grups. Ara les etiquetes són grups, els grups mantenen la funcionalitat d\'etiquetes i afegeixen: gestió d\'usuaris, gestió ampliada de factures.',
          'Actualització del perfil d\'usuari amb informació sobre els grups a què pertany.',
        ]
      },
    ]
  }, 
  {
    title: 'Versió 4.1.0',
    date: '2023-08-11', // '11 de Agosto de 2023',
    changes: [
      {
        title: 'Noves característiques',
        description: [
          'Incorporació de recepció de factures als PGE FACe i FACeB2B.',
          'Nous mòduls disponibles per contractar. Podeu consultar-los a la secció de configuració general.'
        ]
      },
    ]
  }, 
  {
    title: 'Versió 4.0.0',
    date: '2023-05-24', // '24 de Mayo de 2023',
    changes: [
      {
        title: 'Llançament',
        description: [
          // 'Gestió i administració de ...',
        ]
      },
    ]
  }, 
  // {
  //   title: 'Versió 2.11.0',
  //   date: '2022-12-13', // '13 de Diciembre de 2022',
  //   changes: [
  //     {
  //       title: 'Noves característiques',
  //       description: [
  //         'Nou tipus d\'usuari: Usuari Consulta. Usuari per a consulta i revisió de dades, similar al rol "Usuari" amb restriccions a l\'hora de realitzar accions sobre factures, només les pot visualitzar i descarregar-ne el contingut.',
  //         'Nova funcionalitat d\'edició i eliminació de Metadades Addicionals d\'una factura, accessible al detall de les factures.',
  //         'S\'ha afegit l\'opció d\'exportar un fitxer excel dels errors detectats des del quadre de diàleg dels detalls d\'errors del Dashboard.',
  //         'S´ha afegit una nova opció d´exportar un fitxer excel de l´històric complet dels errors detectats, d´una empresa i una seu concrets, des del quadre de diàleg dels detalls d´errors del Dashboard.',
  //         'En seleccionar l\'acció "Excloure organisme associat" des de la vista de factures, s\'ha afegit l\'opció d\'excloure aquest organisme a totes les empreses del client, a més de mantenir l\'opció per defecte només excloure l\'organisme a l\'empresa associada a aquesta factura .',
  //       ]
  //     },
  //     {
  //       title: 'Errors corregits',
  //       description: [
  //         'Corregit error a la pujada de factures manualment.',
  //         'Correccions en texts i descripcions.',
  //         'Altres correcions menors',
  //       ]
  //     },
  //   ]
  // }, 
]

export {
  PATCH_NOTES
}

